// overlay-bus.ts — Helper zum Dispatchen von pfs:overlay-Events an
// <pfs-overlay-host> (PFS-580). Schwester zu banner-bus.ts. Konsumer feuern
// die Helper statt CustomEvent-Boilerplate.

import type { PfsOverlayDetail } from "../components/overlay-host/pfs-overlay-host.js";

export type { PfsOverlayDetail };

/**
 * dispatchOverlay feuert ein `pfs:overlay`-Event an window → von
 * <pfs-overlay-host> abgefangen + als Scrim+Card über die ganze App
 * gerendert. Best-effort (Errors geschluckt, z.B. window fehlt im Test).
 *
 * Beispiel — App-Wartung blockieren:
 *   dispatchOverlay({ title: "Wartung", message: "Gleich wieder da.", scrim: "blur", variant: "info" });
 */
export function dispatchOverlay(detail: PfsOverlayDetail): void {
  try {
    window.dispatchEvent(
      new CustomEvent("pfs:overlay", { detail, bubbles: true, composed: true }),
    );
  } catch {
    // Best-effort: window-Dispatch fehlt im Test-Setup
  }
}

/** dispatchOverlayClose schließt das Overlay (optional per id). Best-effort. */
export function dispatchOverlayClose(id?: string): void {
  try {
    window.dispatchEvent(
      new CustomEvent("pfs:overlay-close", { detail: { id }, bubbles: true, composed: true }),
    );
  } catch {
    // ignore
  }
}
